export function normalizePartnerWhatsappConversationDetail(body = {}) {
  return {
    success: body.success !== false,
    conversation: body.conversation || null,
    workflow: body.workflow || null,
    dealer: body.dealer || null,
    redactionPolicyVersion: body.redactionPolicyVersion || null,
  };
}

export function normalizePartnerWhatsappTimeline(body = {}) {
  return {
    success: body.success !== false,
    crmLeadId: body.crmLeadId || null,
    brokerStatus: body.brokerStatus || null,
    items: Array.isArray(body.items) ? body.items : [],
    degraded: body.degraded === true,
    messageCount: body.messageCount ?? 0,
    auditEventCount: body.auditEventCount ?? 0,
    redactionPolicyVersion: body.redactionPolicyVersion || null,
  };
}

export function formatTimelineTimestamp(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function timelineDirectionBadge(item = {}) {
  if (item.type === "audit") {
    return { code: "SYS", label: "System", tone: "slate" };
  }
  if (item.direction === "OUTBOUND") {
    return { code: "OUT", label: "Outbound", tone: "blue" };
  }
  if (item.direction === "INBOUND") {
    return { code: "IN", label: "Inbound", tone: "green" };
  }
  return { code: "—", label: "Message", tone: "slate" };
}

export function timelineRoleLabel(item = {}) {
  if (item.type === "audit") return "System";
  if (item.senderRole === "buyer" || item.recipientRole === "buyer") return "Buyer";
  if (item.senderRole === "dealer" || item.recipientRole === "dealer") return "Dealer";
  if (item.senderRole === "system") return "System";
  return "—";
}

export function formatWorkflowAge(minutes) {
  if (minutes == null || Number.isNaN(Number(minutes))) return "—";
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  const remainder = minutes % 60;
  if (hours < 48) {
    return remainder ? `${hours} hr ${remainder} min` : `${hours} hr`;
  }
  const days = Math.floor(hours / 24);
  return `${days} day${days === 1 ? "" : "s"}`;
}

export function mapPortalAccessStatus(status) {
  switch (status) {
    case "enabled":
      return "Enabled";
    case "disabled_or_unknown":
      return "Disabled or unknown";
    default:
      return "Unknown";
  }
}

export function mapWhatsappStatus(status) {
  switch (status) {
    case "valid":
      return "Valid";
    case "present_unverified":
      return "Present (unverified)";
    case "missing":
      return "Missing";
    default:
      return status || "Unknown";
  }
}

export function mapVendorSyncStatus(status) {
  switch (status) {
    case "synced":
      return "Synced";
    case "unknown":
      return "Unknown";
    default:
      return status || "Unknown";
  }
}
